import { SortItem } from './member.dashboard.license.response';

export class GlobalAddressWhitelistBasic {
    ID: number;
    DateTimeCreated: Date;
    Address: string;
    FuzzyAddress: string;
    City: string;
    State: string;
    ZipCode: string;
    Country: string;

    public static FixDates(item: GlobalAddressWhitelistBasic) {
        item.DateTimeCreated = new Date(item.DateTimeCreated);
    }

}

export class GlobalAddressWhitelistBasicArray extends Array<GlobalAddressWhitelistBasic> {
    public LastSort: SortItem;

    constructor(...items: GlobalAddressWhitelistBasic[]) {
        super(...items);
        Object.setPrototypeOf(this, GlobalAddressWhitelistBasicArray.prototype);
    }

    public static FixDates(item: GlobalAddressWhitelistBasicArray) {
        item.forEach(x => GlobalAddressWhitelistBasic.FixDates(x));
    }

}
